// Pass 6.3.6 — shared Sign Out affordance for authenticated page
// headers. Self-contained: pulls logout() from AuthContext, so a
// page only has to drop <SignOutButton /> into its header's
// top-right. Clearing auth flips the route guard, which redirects
// to /login. Matches the existing TopNav sign-out styling.

import { LogOut } from "lucide-react";

import { useAuth } from "../state/AuthContext";

export function SignOutButton() {
  const { logout } = useAuth();
  return (
    <button
      type="button"
      onClick={logout}
      data-testid="sign-out-button"
      className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-white/[0.04] border border-white/[0.1] text-[12px] font-medium text-theme-text-secondary hover:text-theme-error-text hover:border-theme-error-border/50 transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-theme-focus-ring"
    >
      <LogOut className="w-3.5 h-3.5" strokeWidth={1.75} aria-hidden />
      Sign out
    </button>
  );
}
